import React from 'react';

import { DEFAULT_PHONE_CODE } from '@clearverify/constants';

import { formatPhoneNumberForFormValues } from 'src/utils/phoneNumber';

import { MaskedTextField, MaskedTextFieldProps } from '../MaskedTextField';

type PhoneFieldProps = Omit<MaskedTextFieldProps, 'mask'>;

export const PhoneField: React.FC<PhoneFieldProps> = ({ inputProps, ...restProps }) => {
  return (
    <MaskedTextField
      inputProps={{ placeholder: `${DEFAULT_PHONE_CODE} ${PHONE_EMPTY_NUM}`, ...inputProps }}
      mask={`${DEFAULT_PHONE_CODE} ${PHONE_EMPTY_MASK}`}
      valueFormatter={formatPhoneNumberForFormValues}
      {...restProps}
    />
  );
};

const PHONE_EMPTY_MASK = '(###) ###-####';
const PHONE_EMPTY_NUM = PHONE_EMPTY_MASK.replace(/#/g, '0');
